import { render, staticRenderFns } from "./TableBudgetContentBody.vue?vue&type=template&id=30b8c577&scoped=true&"
import script from "./TableBudgetContentBody.vue?vue&type=script&lang=js&"
export * from "./TableBudgetContentBody.vue?vue&type=script&lang=js&"
import style0 from "./TableBudgetContentBody.vue?vue&type=style&index=0&id=30b8c577&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8c577",
  null
  
)

export default component.exports